import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'select-site' as const;

const argumentZod = z.object({
  site_id: z
    .string()
    .describe(
      'The id of the site the user chose (from list-sites). It is validated ' +
        'against the sites the caller can access before being committed.'
    ),
});

export const selectSiteManifest = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Select site',
  // Same non-compounded family as list-sites so it stays a literal tool in
  // render mode (the site-resolver agent calls it directly).
  family: 'site-resolution',
  llmTool: {
    name: toolName,
    description:
      'Commit the site the user chose, after confirming it with list-sites. ' +
      'Call this once the target site is unambiguous so the rest of the ' +
      'conversation can act on it. The site id is validated against the sites ' +
      'you can access; an invalid or inaccessible id is rejected. Returns the ' +
      'confirmed site (id, display name, short name).',
    inputSchema: argumentZod,
  },
  type: 'server',
  permission: [{resource: 'SiteMeta', action: 'read'}],
  confirmBeforeExecuting: false,
  isConcurrencySafe: () => true,
  isReadOnly: () => true,
});

export type SelectSiteArgumentType = z.infer<typeof argumentZod>;
